const RenderMgr = require('./RenderMgr');
const SimpleRenderMgr = require('./simple/SimpleRenderMgr');
const StatisticsRenderMgr = require('./statistics/StatisticsRenderMgr');
/**
 * @namespace
 * @memberOf G
 * @alias G.render
 * @description 地图渲染
 */
const components = {
    RenderMgr,
    SimpleRenderMgr,
    StatisticsRenderMgr
};
module.exports = components;